import React from 'react';

const CSS3DHero = () => {
  return (
    <div className="w-full h-full relative flex items-center justify-center">
      {/* Animated Grid Background */}
      <div className="absolute inset-0 overflow-hidden">
        <div
          className="absolute inset-0 opacity-20"
          style={{
            background: 'linear-gradient(#3DF2E0 2px, transparent 2px), linear-gradient(90deg, #3DF2E0 2px, transparent 2px)',
            backgroundSize: '80px 80px',
            animation: 'gridMove 20s linear infinite',
            transform: 'perspective(600px) rotateX(60deg)'
          }}
        />
        {/* Pixel Robot Illustration */}
        <div className="relative w-[340px] sm:w-[460px] lg:w-[600px] h-auto flex items-center justify-center">

          <img
            src="/finalrobot.gif"
            alt="AI Robot Working"
            className="w-full h-auto object-contain hero-blend"
          />

        </div>
      </div>

      {/* Floating AI Nodes 
      <div className="relative w-96 h-96">*/}

      {/* Pixel Robot Illustration 
        <div className="relative w-[500px] h-[auto] flex items-center justify-center">

          <img
            src="/Remove background project.png"
            alt="AI Robot Working"
            className="w-full h-full object-contain pixel-art"
          />

        </div>*/}


      {/* Central Sphere 
        <div
          className="absolute top-1/2 left-1/2 w-64 h-64 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-[#3DF2E0]/30"
          style={{
            animation: 'pulse 4s ease-in-out infinite',
            boxShadow: '0 0 40px rgba(61, 242, 224, 0.2), inset 0 0 40px rgba(61, 242, 224, 0.1)'
          }}
        />*/}

      {/* Orbiting Nodes
        {[0, 60, 120, 180, 240, 300].map((angle, i) => (
          <div
            key={i}
            className="absolute top-1/2 left-1/2 w-4 h-4"
            style={{
              animation: `orbit 12s linear infinite`,
              animationDelay: `${-(i * 2)}s`,
              transformOrigin: '0 0'
            }}
          >
            <div 
              className="w-4 h-4 rounded-full bg-[#3DF2E0]"
              style={{
                boxShadow: '0 0 20px rgba(61, 242, 224, 0.8)',
                animation: 'glow 2s ease-in-out infinite alternate'
              }}
            />
          </div>
        ))} */}

      {/* Connection Lines (simulated with rotating elements) 
        <div 
          className="absolute top-1/2 left-1/2 w-full h-full -translate-x-1/2 -translate-y-1/2"
          style={{
            animation: 'rotate 20s linear infinite'
          }}
        >
          {[0, 45, 90, 135].map((angle, i) => (
            <div
              key={i}
              className="absolute top-1/2 left-1/2 w-full h-px bg-gradient-to-r from-transparent via-[#3DF2E0]/20 to-transparent"
              style={{
                transform: `rotate(${angle}deg)`,
                transformOrigin: 'center'
              }}
            />
          ))}
        </div>*/}
      {/*</div>*/}

      <style>{`
        @keyframes gridMove {
          0% {
            transform: perspective(600px) rotateX(60deg) translateY(0);
          }
          100% {
            transform: perspective(600px) rotateX(60deg) translateY(80px);
          }
        }

        @keyframes pulse {
          0%, 100% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 0.6;
          }
          50% {
            transform: translate(-50%, -50%) scale(1.05);
            opacity: 0.8;
          }
        }

        @keyframes orbit {
          0% {
            transform: rotate(0deg) translateX(140px) rotate(0deg);
          }
          100% {
            transform: rotate(360deg) translateX(140px) rotate(-360deg);
          }
        }

        @keyframes glow {
          0% {
            box-shadow: 0 0 15px rgba(61, 242, 224, 0.6);
          }
          100% {
            box-shadow: 0 0 25px rgba(61, 242, 224, 1);
          }
        }

        @keyframes rotate {
          0% {
            transform: translate(-50%, -50%) rotate(0deg);
          }
          100% {
            transform: translate(-50%, -50%) rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default CSS3DHero;